import { Component } from '@angular/core';
import { BaseDirective } from 'src/app/directives/base.directive';


@Component({
  selector: 'app-patient',
  templateUrl: './patient.component.html',
  styleUrls: ['./patient.component.sass']
})
export class PatientComponent extends BaseDirective {
  override title = 'MENU.PATIENTS';
}
